import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { useSettings } from "@/lib/api";
import { Logo } from "./Navbar";

const COLS = [
  ["Programs", [["Stock Market", "/programs/stock-market"], ["Technical Analysis", "/programs/technical-analysis"], ["F&O", "/programs/fno"], ["NISM Preparation", "/programs/nism"], ["Complete Masterclass", "/programs/complete-masterclass"], ["All Programs", "/programs"], ["Compare Programs", "/programs/compare"]]],
  ["Resources", [["Market Learning Hub", "/blog"], ["FAQs", "/faq"], ["Events", "/events"], ["Student Stories", "/student-stories"], ["Learning Paths", "/learning-paths"]]],
  ["About", [["Our Story", "/about"], ["Mentors", "/mentors"], ["Market Lab", "/market-lab"], ["Community", "/community"], ["Contact", "/contact"]]],
  ["Legal", [["Terms & Conditions", "/terms"], ["Privacy Policy", "/privacy-policy"], ["Disclaimer", "/disclaimer"], ["Risk Disclosure", "/risk-disclosure"]]],
];

export const Footer = () => {
  const { data: s } = useSettings();
  return (
    <footer className="border-t border-white/10 bg-[#050912]" data-testid="footer">
      <div className="container-x py-16 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4 space-y-5">
          <div data-testid="footer-logo"><Logo className="h-16" /></div>
          <p className="text-sm text-slate-400 leading-relaxed max-w-sm">A financial markets education academy in Mohali. Learn the markets. Build the skill. Trade with discipline.</p>
          <ul className="space-y-2.5 text-sm text-slate-300">
            <li className="flex gap-2.5"><MapPin size={16} className="mt-0.5 shrink-0 text-[var(--blue)]" /><span data-testid="footer-address">{s?.address_line1},<br />{s?.address_line2}</span></li>
            <li className="flex gap-2.5"><Phone size={16} className="text-[var(--blue)]" /><a data-testid="footer-phone" href={`tel:${s?.phone?.replace(/\s/g, "")}`} className="hover:text-[var(--blue)]">{s?.phone}</a></li>
            <li className="flex gap-2.5"><Mail size={16} className="text-[var(--blue)]" /><a data-testid="footer-email" href={`mailto:${s?.email}`} className="hover:text-[var(--blue)]">{s?.email}</a></li>
          </ul>
        </div>
        <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-4 gap-8">
          {COLS.map(([h, links]) => (
            <div key={h}>
              <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">{h}</h4>
              <ul className="space-y-2.5">{links.map(([l, to]) => <li key={to}><Link to={to} data-testid={`footer-${l.toLowerCase().replace(/[^a-z]+/g, "-")}-link`} className="text-sm text-slate-300 hover:text-[var(--blue)] transition-colors">{l}</Link></li>)}</ul>
            </div>
          ))}
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="container-x py-6 text-xs text-slate-500 leading-relaxed space-y-3">
          <p data-testid="footer-edu-disclaimer" className="text-slate-300 font-medium">Disclaimer: The House of Trading is an educational institute providing training on financial markets. We do not offer investment advice, buy/sell tips, or guaranteed profit schemes.</p>
          <p data-testid="footer-disclaimer">{s?.disclaimer}</p>
          <p>© {new Date().getFullYear()} The House of Trading. All rights reserved. The House of Trading is an educational platform and is not a SEBI-registered investment adviser or research analyst. NISM certifications are awarded by NISM upon passing their examinations.</p>
        </div>
      </div>
    </footer>
  );
};
